<template>
  <div class="traffic-page dark-theme">
    <!-- 主内容区 -->
    <div class="traffic-container">
      <!-- 流量统计卡片 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="line-chart" class="card-icon" />
          <h3 class="card-title">{{ translate('traffic.title') }}</h3>
        </div>

        <div class="search-section">
          <a-form
            :model="formData"
            @submit.prevent="onSubmit"
            layout="inline"
            class="search-form"
          >
            <a-form-item :label="translate('traffic.form.subAccount')" class="dark-form-item">
              <a-select
                v-model="formData.uname"
                :placeholder="translate('traffic.form.selectSubAccount')"
                style="min-width: 300px"
                allow-clear
                @change="changeSon"
                @clear="handleClear"
                class="dark-select"
              >
                <a-select-option value="all">{{ translate('traffic.form.all') }}</a-select-option>
                <a-select-option
                  v-for="item in sonlist"
                  :key="item.upid"
                  :value="item.username"
                >
                  {{ item.username }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="onSubmit" class="action-btn">{{ translate('traffic.form.search') }}</a-button>
            </a-form-item>
          </a-form>
        </div>

        <!-- echarts图表容器 -->
        <div
          id="traffic-chart"
          class="traffic-chart"
          style="width: 100%; height: 520px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import * as echarts from 'echarts'

export default {
  name: 'TrafficPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        uname: 'all',
      },
      timer: '', // 定时器名称
      sonlist: [],
      flowlist: [],
      timelist: [],
      uid: localStorage.getItem('userId'),
      charts: null,
    }
  },
  watch: {
    'formData.uname'(newVal) {
      if (newVal === undefined || newVal === null) {
        this.formData.uname = 'all'
      }
    }
  },
  methods: {
    // 国际化翻译方法
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'traffic.title': lang === 'zh' ? '流量使用概括' : 'Traffic Usage Summary',
        'traffic.form.subAccount': lang === 'zh' ? '子账户' : 'Sub Account',
        'traffic.form.selectSubAccount': lang === 'zh' ? '请选择子账户' : 'Please select sub account',
        'traffic.form.all': lang === 'zh' ? '全部' : 'All',
        'traffic.form.search': lang === 'zh' ? '查询' : 'Search',
        'traffic.chart.title': lang === 'zh' ? '流量使用趋势' : 'Traffic Usage Trend',
        'traffic.chart.yAxis': lang === 'zh' ? '流量(G)' : 'Traffic (G)',
        'traffic.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          message.warning(this.translate('traffic.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 初始化图表
    initChart(id) {
      if (!this.charts || this.charts.isDisposed()) {
        this.charts = echarts.init(document.getElementById(id))
      }
    },
    // 更新图表数据
    updateChart(data) {
      if (!this.charts) {
        this.initChart('traffic-chart')
      }
      
      if (this.charts) {
        this.flowlist = []
        this.timelist = []
        data.forEach((item) => {
          this.flowlist.push(item.flowOverdueChange)
          this.timelist.push(item.createrTime)
        })
        
        this.charts.setOption({
          backgroundColor: 'transparent',
          title: {
            left: '3%',
            top: '2%',
            text: this.translate('traffic.chart.title'),
            textStyle: {
              color: '#ffffff',
              fontSize: 16,
              fontWeight: 600,
            },
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(30, 41, 59, 0.95)',
            borderColor: 'rgba(21, 129, 198, 0.3)',
            borderWidth: 1,
            textStyle: {
              color: '#ffffff',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: 'rgba(21, 129, 198, 0.5)',
              },
              crossStyle: {
                color: 'rgba(21, 129, 198, 0.5)',
              },
            },
          },
          grid: {
            top: '20%',
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            data: this.timelist,
          },
          yAxis: {
            name: this.translate('traffic.chart.yAxis'),
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            type: 'value',
            boundaryGap: true,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisTick: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
            },
          },
          series: [{
            type: 'line',
            data: this.flowlist,
            smooth: true,
            lineStyle: {
              width: 3,
              color: '#1581c6',
            },
            itemStyle: {
              radius: 6,
              color: '#1581c6',
              borderColor: '#000000',
              borderWidth: 2,
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(21, 129, 198, 0.3)'
                }, {
                  offset: 1, color: 'rgba(21, 129, 198, 0.05)'
                }],
              },
            },
            emphasis: {
              itemStyle: {
                radius: 8,
                shadowColor: 'rgba(21, 129, 198, 0.5)',
                shadowBlur: 10,
              },
            },
          }],
        }, true)
      }
    },
    // 绘制折线图
    drawLine(id) {
      this.initChart(id)
      this.fetchTrafficData()
    },
    // 获取流量数据
    fetchTrafficData() {
      this.$request.get(`/his/polyline?uname=${this.formData.uname}&uid=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.updateChart(res.data.data)
        }
      }).catch((e) => { console.log(e) })
    },
    // 子账户变化监听
    changeSon() {
      this.$request.get(`/ums/Pro/selectSonAccount?id=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data
        }
      }).catch((e) => { console.log(e) })
    },
    // 查询提交
    onSubmit() {
      this.fetchTrafficData()
    },
    // 处理清空事件
    handleClear() {
      this.formData.uname = 'all'
    },
    // 窗口大小变化处理函数
    handleResize() {
      if (this.charts) {
        this.charts.resize()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawLine('traffic-chart')
    })
    this.changeSon()
    this.start()
    // 添加窗口大小变化事件监听器
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.charts) {
      this.charts.dispose()
    }
    // 移除窗口大小变化事件监听器
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  color: #ffffff;
  min-height: 100vh;
}

// 主容器样式
.traffic-container {
  padding: 20px;
  // max-width: 1600px;
  margin: 0 auto;
}

// 卡片通用样式
.section-card {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff !important;

  &:hover {
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(21, 129, 198, 0.2);
}

.card-icon {
  font-size: 20px;
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 搜索区域
.search-section {
  margin-bottom: 24px;
  padding: 20px;
  background: rgba(21, 129, 198, 0.05);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 12px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.dark-form-item {
  :deep(.ant-form-item-label > label) {
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
  }
}

// 深色选择器 - 使用最高优先级选择器
.dark-select,
:deep(.dark-select),
:deep(.ant-select),
:deep(.ant-select-selector),
:deep(.ant-select-selection),
:deep(.ant-select-selection--single),
:deep(.ant-select-selection__rendered) {
  background: #000000 !important;
  // border: 1px solid rgba(21, 129, 198, 0.5) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

// 确保选择器内所有文字为白色
:deep(.ant-select-selection-placeholder),
:deep(.ant-select-selection-item),
:deep(.ant-select-selection-selected-value),
:deep(.ant-select-dropdown-menu-item),
:deep(.ant-select-selection__rendered),
:deep(.ant-select-selection__rendered > div) {
  color: #ffffff !important;
  opacity: 1 !important;
  background: transparent !important;
}

// 确保选择器内的SVG图标可见
:deep(.ant-select-arrow),
:deep(.ant-select-clear-icon),
:deep(.anticon),
:deep(.ant-select-arrow svg),
:deep(.ant-select-clear-icon svg),
:deep(.anticon svg),
:deep(.ant-select-arrow .anticon),
:deep(.ant-select-clear-icon .anticon),
:deep(.ant-select-arrow .anticon svg),
:deep(.ant-select-clear-icon .anticon svg) {
  color: rgba(255, 255, 255, 0.7) !important;
  fill: rgba(255, 255, 255, 0.7) !important;
  opacity: 1 !important;
  background: transparent !important;
}

:deep(.ant-select-arrow:hover),
:deep(.ant-select-clear-icon:hover),
:deep(.anticon:hover),
:deep(.ant-select-arrow:hover svg),
:deep(.ant-select-clear-icon:hover svg),
:deep(.anticon:hover svg),
:deep(.ant-select-arrow:hover .anticon),
:deep(.ant-select-clear-icon:hover .anticon),
:deep(.ant-select-arrow:hover .anticon svg),
:deep(.ant-select-clear-icon:hover .anticon svg) {
  color: #ffffff !important;
  fill: #ffffff !important;
  opacity: 1 !important;
  background: transparent !important;
}

// 确保下拉菜单样式正确
:deep(.ant-select-dropdown) {
  background: rgba(30, 41, 59, 0.95) !important;
  border: 1px solid rgba(21, 129, 198, 0.3) !important;
  border-radius: 8px !important;
}

:deep(.ant-select-dropdown-menu) {
  background: transparent !important;
}

// 确保选择器清除按钮可见
:deep(.ant-select-selection__clear) {
  color: rgba(255, 255, 255, 0.7) !important;
  opacity: 1 !important;
  background: transparent !important;
  
  &:hover {
    color: #ffffff !important;
    background: rgba(21, 129, 198, 0.2) !important;
  }
}

// 针对用户选择的具体元素结构进行样式修改 - 最高优先级
:deep([role="combobox"].ant-select-selection),
:deep([role="combobox"].ant-select-selection--single),
:deep([role="combobox"] .ant-select-selection__rendered),
:deep([role="combobox"] .ant-select-selection__placeholder),
:deep([role="combobox"] .ant-select-selection-selected-value),
:deep([role="combobox"] .ant-select-selection-item),
:deep([role="combobox"] .ant-select-selection__clear),
:deep([role="combobox"] .ant-select-arrow),
:deep([role="combobox"] .anticon),
:deep([role="combobox"] svg),
:deep(.ant-select-selection),
:deep(.ant-select-selection--single),
:deep(.ant-select-selection__rendered),
:deep(.ant-select-selection__placeholder),
:deep(.ant-select-selection-selected-value),
:deep(.ant-select-selection-item),
:deep(.ant-select-selector),
:deep(.ant-select-selector *),
:deep(.ant-select),
:deep(.ant-select *),
:deep(.ant-select-search__field),
:deep(.ant-select-search__field__wrap),
:deep(.ant-select-dropdown),
:deep(.ant-select-dropdown *),
:deep(.ant-select-dropdown-menu),
:deep(.ant-select-dropdown-menu *),
:deep(.ant-select-dropdown-menu-item),
:deep(.ant-select-dropdown-menu-item *) {
  background: #000000 !important;
  color: #ffffff !important;
  border-color: rgba(21, 129, 198, 0.5) !important;
  box-shadow: none !important;
  opacity: 1 !important;
}

// 确保所有SVG图标颜色正确
:deep(.ant-select-arrow),
:deep(.ant-select-clear-icon),
:deep(.anticon),
:deep(.ant-select-arrow svg),
:deep(.ant-select-clear-icon svg),
:deep(.anticon svg),
:deep(.ant-select-arrow .anticon),
:deep(.ant-select-clear-icon .anticon),
:deep(.ant-select-arrow .anticon svg),
:deep(.ant-select-clear-icon .anticon svg),
:deep(.ant-select-dropdown-menu-item .anticon),
:deep(.ant-select-dropdown-menu-item .anticon svg) {
  color: rgba(255, 255, 255, 0.7) !important;
  fill: rgba(255, 255, 255, 0.7) !important;
  opacity: 1 !important;
}

// 确保输入框占位符为白色
:deep(.ant-select-search__field::placeholder),
:deep(.ant-select-selection__placeholder) {
  color: rgba(255, 255, 255, 0.4) !important;
}

// 按钮样式
.action-btn {
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
  border: none !important;
  padding: 6px 32px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  transition: all 0.3s ease !important;
  box-sizing: content-box;

  &:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(21, 129, 198, 0.5) !important;
  }

  & span {
    color: #ffffff !important;
  }
}

// 深色图表容器
.traffic-chart {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(21, 129, 198, 0.2) !important;
  transition: all 0.3s ease;
  padding: 20px;
  height: 520px !important;
  width: 100% !important;

  &:hover {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
}

// 表单样式补充
:deep(.ant-form-inline .ant-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

// 响应式设计
@media (max-width: 768px) {
  .traffic-container {
    padding: 16px;
  }

  .search-form {
    flex-direction: column;
    align-items: stretch;
  }

  :deep(.ant-form-inline .ant-form-item) {
    margin-right: 0;
    margin-bottom: 16px;
  }

  .traffic-chart {
    height: 400px !important;
    padding: 16px;
  }
}
</style>